import { getLoggedIn } from '@hotjar/webapp/domains/common/user-data';
import type { Feature } from './Feature';
import type { SiteWithAccountOrg } from './SiteWithAccountOrg';

/**
 * Returns the list of all features without gates
 */
export function getAllWithoutGates(site: SiteWithAccountOrg | null): Feature[] {
  if (!site || !getLoggedIn()) {
    return [];
  }

  const { features: siteFeatures = [], organization = {}, account = {} } = site;
  const { features: organizationFeatures = [] } = organization;
  const { features: accountFeatures = [] } = account;

  return [...siteFeatures, ...organizationFeatures, ...accountFeatures];
}
